import supplierApi from './supplierApi';

export const supplierAuthService = {
  // Login supplier
  login: async (credentials) => {
    try {
      const response = await supplierApi.post('/api/supplier/id', credentials);
      
      return response.data;
    } catch (error) {
      console.error('Supplier login error:', error);
      throw error;
    }
  },

  // Register supplier
  register: async (registrationData) => {
    try {
      const response = await supplierApi.post('/api/supplier/register', registrationData);
      
      return response.data;
    } catch (error) {
      console.error('Supplier registration error:', error);
      throw error;
    }
  },

  // Reset password
  resetPassword: async (resetData) => {
    try {
      const response = await supplierApi.post('/api/supplier/reset', resetData);
      
      return response.data;
    } catch (error) {
      console.error('Supplier password reset error:', error);
      throw error;
    }
  },

  // Setup new password after reset
  setupPassword: async (passwordData) => {
    try {
      const response = await supplierApi.post('/api/supplier/setup_password', passwordData);
      
      return response.data;
    } catch (error) {
      console.error('Supplier password setup error:', error);
      throw error;
    }
  },

  // Get supplier profile
  getProfile: async (token) => {
    try {
      const response = await supplierApi.get(`/api/supplier/profile/${token}`);
      return response.data;
    } catch (error) {
      console.error('Get supplier profile error:', error);
      throw error;
    }
  },

  // Authenticate token
  authenticate: async (token) => {
    try {
      const response = await supplierApi.get(`/api/supplier/authenticate/${token}`);
      return response.data;
    } catch (error) {
      console.error('Supplier authenticate error:', error);
      throw error;
    }
  },

  // Get authenticated supplier data
  getAuthenticated: async (token) => {
    try {
      const response = await supplierApi.get(`/api/supplier/authenticated/${token}`);
      return response.data;
    } catch (error) {
      console.error('Get authenticated supplier error:', error);
      throw error;
    }
  }
};

export default supplierAuthService;
